import { getLanguage } from '../../../../../EbaySweden.TouchWeb/Areas/Selling/static/script/app_react/utils/language';

export default state => {
    state = state || {
        preferredLanguage: getLanguage()
    };

    return state;
};
